import { registerBlockType } from "@wordpress/blocks";

import PageHeader from "./page-header";
import AgendaHeader from "./agenda-header";
import Accordeon from './content-accordeon';
import Contact from './content-contact';
import ContactDeprecatedV1 from './content-contact/deprecated/v1';
import Link from './content-link-section';
import OneColumn from './content-one-column';
import OneColumnDeprecatedV1 from './content-one-column/deprecated/v1';
import Slide from './content-slide';
import Slider from './content-slider';
import Tab from './content-tab';
import Tabs from './content-tabs';
import Testimonial from './content-testimonial';
import ThreeColumns from './content-three-columns';
import TwoColumns from './content-two-columns';
import DatePicker from './date-picker';
import HeaderImage from './header-image';
import ImageText from './image-and-text';
import Leaflet from './leaflet';

registerBlockType("abs/page-header", PageHeader);
registerBlockType("abs/agenda-header", AgendaHeader);
registerBlockType("abs/content-accordeon-block", Accordeon);
registerBlockType("abs/content-contact-block", {
  ...Contact,
  deprecated: [ContactDeprecatedV1],
});
registerBlockType("abs/content-link-section-block", Link);
registerBlockType("abs/content-one-column-block", {
  ...OneColumn,
  deprecated: [OneColumnDeprecatedV1],
});
registerBlockType("abs/content-two-column-block", TwoColumns);
registerBlockType("abs/content-three-column-block", ThreeColumns);
registerBlockType("abs/content-slide-block", Slide);
registerBlockType("abs/content-slider-block", Slider);
registerBlockType("abs/content-tab-block", Tab);
registerBlockType("abs/content-tabs-block", Tabs);
registerBlockType("abs/content-testimonial-block", Testimonial);
registerBlockType("drupal/date-picker", DatePicker);
registerBlockType("abs/header-image-block", HeaderImage);
registerBlockType("abs/image-and-text-block", ImageText);
registerBlockType("drupal/leaflet", Leaflet);
